import React from 'react';
import ReactDOM from 'react-dom';
import FavoriteButton from 'browse/components/favorite-button';

export default (node, clientId, favoriteUrl, isFavorite) => {
    ReactDOM.render(<FavoriteButton isFavorite={isFavorite} favoriteUrl={favoriteUrl} />, node);
};



// WEBPACK FOOTER //
// ./src/web/js/browse/apps/favoriting/init-favoriting-buttons.jsx